var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      ref: "menu",
      attrs: {
        "close-on-content-click": false,
        transition: "scale-transition",
        "offset-y": "",
        "max-width": "350px",
      },
      on: { input: _vm.openPicker },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "ac__dtp-field",
                      attrs: {
                        value: _vm.formattedDateTime,
                        label: _vm.computedLabel,
                        placeholder: "DD/MM/YYYY HH:MM",
                        "persistent-placeholder": "",
                        "hide-details": _vm.hideDetails,
                        outlined: _vm.outlined,
                        dense: _vm.dense,
                        "prepend-inner-icon": _vm.prependInnerIcon,
                        readonly: "",
                      },
                    },
                    "v-text-field",
                    attrs,
                    false
                  ),
                  on
                )
              ),
              _vm.showUnix
                ? _c("div", { staticClass: "ac__unix" }, [
                    _vm._v(" unix: "),
                    _c("b", [_vm._v(_vm._s(_vm.value))]),
                  ])
                : _vm._e(),
            ]
          },
        },
      ]),
      model: {
        value: _vm.isMenuVisible,
        callback: function ($$v) {
          _vm.isMenuVisible = $$v
        },
        expression: "isMenuVisible",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-tabs",
            {
              attrs: { "fixed-tabs": "" },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("v-tab", [_c("v-icon", [_vm._v("mdi-calendar-month")])], 1),
              _c("v-tab", [_c("v-icon", [_vm._v("mdi-clock-outline")])], 1),
            ],
            1
          ),
          _c(
            "v-tabs-items",
            {
              staticClass: "ac__tab-content",
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "v-tab-item",
                [
                  _c("v-date-picker", {
                    staticClass: "ac__date-picker",
                    attrs: { width: "300px" },
                    on: { input: _vm.onDateSelect },
                    model: {
                      value: _vm.date,
                      callback: function ($$v) {
                        _vm.date = $$v
                      },
                      expression: "date",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-tab-item",
                [
                  _c("v-time-picker", {
                    staticClass: "ac__time-picker",
                    attrs: { format: "24hr", width: "300px" },
                    on: { input: _vm.onTimeSelect },
                    model: {
                      value: _vm.time,
                      callback: function ($$v) {
                        _vm.time = $$v
                      },
                      expression: "time",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.savePicker } },
                [_vm._v("OK")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }